var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ais-Pagination-link custom-pagination-button",class:{
    'ais-Pagination-item ais-Pagination-item--page': !_vm.isArrowButton,
    'ais-Pagination-item--disabled': _vm.isDisabled && !_vm.isSelected,
    'ais-Pagination-item--selected': _vm.isSelected
  },attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }